import { UIIncident } from '../../../../../../../api/teamMetricsApi';

export const FILTERABLE_COLUMNS = [
  'Description',
  'SEV Level V2\n(Calculated)',
  'Criticality\n(Calculated)',
  'Product Impact Level',
  '3rd Party Incident',
  'Team',
  'Causing Repo',
  'Affected Product Area',
  'Product Area Detail',
  'Product\n(calculated)',
  'Feature\n(calculated)',
  'Product.Feature',
  'Detection Method',
  'Preferred Detection Method',
  'Resolution Category',
  'Prevention Categories',
  'Data Breach',
  'Incident Commander',
  'Assigned Technical POC',
  'Assigned Support POC',
] as const;

export type FilterableColumn = (typeof FILTERABLE_COLUMNS)[number];

export interface IncidentFilter {
  column: FilterableColumn;
  values: string[];
  isNot?: boolean;
}

export type { UIIncident };
